import React, { useEffect, useRef, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Card, message, Button, Typography, Spin } from 'antd';

type UnsubscribeStatus = 'loading' | 'success' | 'already' | 'error';

const UnsubscribePage: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [status, setStatus] = useState<UnsubscribeStatus>('loading');
  const hasRequested = useRef(false);

  useEffect(() => {
    if (!token || hasRequested.current) {
      if (!token) {
        setStatus('error');
      }
      return;
    }
    hasRequested.current = true;
    setStatus('loading');
    const unsubscribe = async () => {
      try {
        const response = await fetch(`/api/admin/email/unsubscribe/${token}`, {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
          },
          credentials: 'include',
        });
        const data = await response.json();
        if (data.success) {
          if (data.code === 'already') {
            setStatus('already');
            message.info('Вы уже отписаны от email рассылок');
          } else {
            setStatus('success');
            message.success('Вы успешно отписались от email рассылок');
          }
        } else {
          setStatus('error');
          message.error('Ошибка при отписке от рассылки');
        }
      } catch (error) {
        setStatus('error');
        message.error('Ошибка при отписке от рассылки');
      }
    };

    unsubscribe();
  }, [token]);

  return (
    <div
      style={{
        maxWidth: 520,
        margin: '60px auto',
        padding: '0 20px',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <Card style={{ width: '100%', textAlign: 'center', padding: '20px 30px' }}>
        {status === 'loading' && (
          <div style={{ padding: '30px 0' }}>
            <Spin size="large" />
            <Typography.Paragraph style={{ marginTop: 16 }}>
              Обработка запроса...
            </Typography.Paragraph>
          </div>
        )}

        {status === 'success' && (
          <>
            <Typography.Title level={3}>Вы успешно отписались</Typography.Title>
            <Typography.Paragraph style={{ fontSize: 16 }}>
              Вы больше не будете получать письма об обновлениях материалов, но уведомления в кабинете останутся доступными.
            </Typography.Paragraph>
            <Button type="primary" onClick={() => navigate('/')} style={{ marginTop: 24 }}>
              Перейти на главную
            </Button>
          </>
        )}

        {status === 'already' && (
          <>
            <Typography.Title level={3}>Вы уже отписаны</Typography.Title>
            <Typography.Paragraph style={{ fontSize: 16 }}>
              Для этого адреса письма об обновлениях уже были отключены. Вы можете включить их в настройках профиля.
            </Typography.Paragraph>
            <Button type="primary" onClick={() => navigate('/')} style={{ marginTop: 24 }}>
              Перейти на главную
            </Button>
          </>
        )}

        {status === 'error' && (
          <>
            <Typography.Title level={3}>Ошибка</Typography.Title>
            <Typography.Paragraph style={{ fontSize: 16 }}>
              Не удалось обработать запрос. Возможно, ссылка устарела или уже была использована.
            </Typography.Paragraph>
            <Button onClick={() => navigate('/')} style={{ marginTop: 24 }}>
              Вернуться на главную
            </Button>
          </>
        )}
      </Card>
    </div>
  );
};

export default UnsubscribePage;

